import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Bag(props) {
    return (
        <SvgIcon {...props}>
            <path d="M21.9 7c-.4-3-3-5-5.9-5-3 0-5.5 2-5.9 5H3v17.5C3 27.3 5.2 30 8 30h16c2.8 0 5-2.7 5-5.5V7h-7.1zM16 4c1.9 0 3.5 1 3.9 3h-7.8c.4-2 2-3 3.9-3zm10.8 20.5v.8c-.3 1.9-1.3 2.1-2.8 2.7H8c-1.7 0-3-1.8-3-3.5V9h5v2.6h1.9V9h8v2.6h1.9V9h5v15.5z" />
        </SvgIcon>
    );
}

Bag.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Bag;
